import { Box as MuiBox, BoxProps } from "@mui/material";

interface IBlockProps extends BoxProps {}

/**
 * Универсальная карточка приложения. На светлой теме — белая с
 * очень мягкой тенью в стиле Apple (карточка «плавает» над серым
 * фоном #F5F5F7). На тёмной — просто чуть более светлый уровень,
 * тень не даёт эффекта, поэтому её выключаем.
 */
export const Block: React.FC<IBlockProps> = (props) => {
  return (
    <MuiBox
      {...props}
      sx={(theme) => ({
        width: "100%",
        backgroundColor: "secondary.main",
        borderRadius: "24px",
        padding: "16px",
        boxShadow:
          theme.palette.mode === "light"
            ? "0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.02)"
            : "none",
        border:
          theme.palette.mode === "light"
            ? "1px solid rgba(0, 0, 0, 0.04)"
            : "none",
        ...(typeof props.sx === "function"
          ? props.sx(theme)
          : (props.sx as object)),
      })}
    >
      {props.children}
    </MuiBox>
  );
};
